/* tslint:disable */
/* eslint-disable */

/**
 * What a financing hold is placed on, and so which invoices it
 * applies to:
 *
 * - `client` — every invoice of the client;
 * - `end_customer` — every invoice billed to the end customer, and to
 *   any other end-customer row with the same trimmed, non-empty
 *   business id;
 * - `invoice` — that invoice alone.
 */
export enum FinancingHoldScope {
  Client = 'client',
  EndCustomer = 'end_customer',
  Invoice = 'invoice'
}
